__turbopack_context__.v({
  "invitation": "styles-module-scss-module__CqYrAW__invitation",
  "snackbar": "styles-module-scss-module__CqYrAW__snackbar",
  "snackbar-close": "styles-module-scss-module__CqYrAW__snackbar-close",
  "snackbar-wrapper": "styles-module-scss-module__CqYrAW__snackbar-wrapper",
  "wrapper-visible": "styles-module-scss-module__CqYrAW__wrapper-visible",
});
